import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllFilesAndFoldersByUserDto } from '../types/FolderPermission';

interface ResourceModifiedSliceState {
 modifiedRow : GetAllFilesAndFoldersByUserDto | null;
 type: string;
}

const initialState: ResourceModifiedSliceState = {
  modifiedRow: null,
  type:""
};

 const resourceModifiedSlice = createSlice({
  name: 'ResourceModified',
  initialState,
  reducers: {
    setResourceModified(state, action: PayloadAction<{ modifiedRow: GetAllFilesAndFoldersByUserDto | null; type: string }>) {
      state.modifiedRow = action.payload.modifiedRow;
      state.type = action.payload.type;
    },
    clearResourceModified(state) {
     state.modifiedRow = null;
     state.type = "";
    },
  },
});

export const { setResourceModified, clearResourceModified } = resourceModifiedSlice.actions;

export default resourceModifiedSlice.reducer;
